import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'popper.js'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import { VBTooltip } from 'bootstrap-vue'
import { CollapsePlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { TablePlugin } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(CollapsePlugin)
Vue.directive('b-tooltip', VBTooltip)
Vue.use(PaginationPlugin)
Vue.use(ImagePlugin)
Vue.use(FormPlugin)
Vue.use(TablePlugin)